// 検索用の正規化関数を専用モジュールに分離
// ひらがな/カタカナの揺れと英字の大小を吸収して一致判定をしやすくする
// 注意: UI側のAutocompleteなどから利用することを想定
export const normalizeForSearch = (str: string): string => {
  // 小文字化してから、ひらがな→カタカナへ寄せる
  return str.toLowerCase().replace(/[\u3041-\u3096\u30A1-\u30F6]/g, (match) => {
    // ひらがな範囲をカタカナに変換
    if (match >= "\u3041" && match <= "\u3096") {
      return String.fromCharCode(match.charCodeAt(0) + 0x60);
    }
    // すでにカタカナの場合はそのまま
    return match;
  });
};
